import { OutgoingGetInvoiceListProps } from '../../../types/Invoicing/InvoiceAuditReport/invoiceAuditReportType'

export const outgoingInitialGetInvoiceListProperties: OutgoingGetInvoiceListProps =
  {
    status: [],
  }
export const filterOptionsStatus: string[] = [
  'SENT',
  'PARTIALLY RECEIVED',
  'RECEIVED',
  'WRITE OFF',
]
export const getIndexOfInvoicesFromList = (
  list: string[],
  value: string,
): null | number => {
  const indexVal = list.findIndex((ratingVal) => ratingVal === value)
  return indexVal === -1 ? null : indexVal
}
export const getStatusListTestId = (value: string): string => {
  return `statuslist-${value}`
}
